import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const FailedToRemoveUser = ({ handleRemoveUserFailed }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleRemoveUserFailed}>
            <div>
                <Alert
                    severity="error"
                    contrast="normal"
                    width="toast"
                    onClose={handleRemoveUserFailed}
                    title={formatMessage(Locale.error)}>
                    <AlertTitle>{formatMessage(Locale.error)}</AlertTitle>
                    {formatMessage(Locale.bulkImportRemoveUserFailed)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default FailedToRemoveUser;
